<div class="address-container" *ngIf="addressArray.length > 0">
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
  >
    <!-- [(ngModel)]="selectedAddress" FIXME: add this binding -->
    <mat-radio-button
      class="example-radio-button"
      *ngFor="let address of addressArray; index as i"
      [value]="address.id"
      (change)="select(i)"
    >
      <app-address
        (click)="select(i)"
        [isSelected]="isSelected(address)"
        [address]="address"
      />
    </mat-radio-button>
  </mat-radio-group>
</div>

<div
  *ngIf="contentLoaded && addressArray.length === 0"
  style="text-align: center"
>
  <h3>هیچ آدرسی موجود نیست</h3>
</div>

<div
  fxLayout="row"
  fxLayoutAlign="center center"
  *ngIf="!contentLoaded"
  style="padding: 50px"
>
  <mat-spinner></mat-spinner>
</div>
